import {
  subCategoryPathSegment,
  type IdValue
} from '../../../../utils/companyCategorySubCategory';
import {cbamIronAndSteelSubCategories} from '../frameworkRoutes';

/** TEMPORARY — set false to restore per-subcategory CBAM gating */
export const CBAM_IRON_AND_STEEL_FOR_ALL_SUBCATEGORIES = true;

/** Single subcategory id sent to CBAM pillars API when override is on */
export const CBAM_API_DEFAULT_SUB_CATEGORY = cbamIronAndSteelSubCategories[0];

export const getCbamEffectiveSubCategory = (
  companySubCategory: IdValue
): IdValue =>
  CBAM_IRON_AND_STEEL_FOR_ALL_SUBCATEGORIES
    ? cbamIronAndSteelSubCategories
    : companySubCategory;

/** TEMPORARY — CBAM pillars API accepts one subcategory id in the path */
export const getCbamApiSubCategoryId = (
  companySubCategory: IdValue
): string | number | undefined =>
  CBAM_IRON_AND_STEEL_FOR_ALL_SUBCATEGORIES
    ? CBAM_API_DEFAULT_SUB_CATEGORY
    : subCategoryPathSegment(companySubCategory);
